export default __webpack_public_path__ + "static/media/laboratorio.f5d72b5a.svg";